export enum ModalitaCaricoMaterialeEsterno {
  Disattiva = 0,
  Aggiungi = 1,
  Sostituisce = 2
}

/**
 * Modificabilità del campo Lotto per l'operatore (issue #3462).
 *
 * In `ConSblocco` e `Fisso` si blocca la sola digitazione — e con essa la scansione, che per uno
 * scanner keyboard-wedge è digitazione. I pulsanti del campo (crea lotto, lotto pianificato,
 * elenco giacenze) restano sempre attivi: l'operatore assegna il lotto, non lo scrive.
 */
export enum ModalitaModificaLotto {
  Libero = 0,
  ConSblocco = 1,
  Fisso = 2
}

/**
 * Modificabilità del campo Quantità per l'operatore (feature 150), stessi valori del lotto.
 *
 * Vale per `app-quantita-input` e per i campi Conforme / Non conforme / Scarto della schermata
 * operatore. In `ConSblocco` e `Fisso` si blocca la sola digitazione (e con essa la scansione e la
 * tastiera a schermo): i pulsanti (±1/10/100/1000, residuo, azzera, parziale, +/-) restano attivi.
 */
export enum ModalitaModificaQuantita {
  Libero = 0,
  ConSblocco = 1,
  Fisso = 2
}

/**
 * Modificabilità del campo Contenitore per l'operatore (feature 165), stessi valori del lotto.
 *
 * Vale per `app-box-input`, salvo Info contenitore (`soloEsistenti`) e i campi già `readonly`. In
 * `ConSblocco` e `Fisso` si blocca la digitazione, e con essa la scansione keyboard-wedge: il
 * contenitore si crea con + o si sceglie dall'elenco, che restano attivi.
 */
export enum ModalitaModificaContenitore {
  Libero = 0,
  ConSblocco = 1,
  Fisso = 2
}

/** Vista del percorso fasi in Info contenitore (feature 166). La predefinita è Orizzontale. */
export enum VistaPercorso {
  Orizzontale = 0,
  Timeline = 1,
  Mappa = 2
}

/**
 * Dettaglio del percorso fasi in Info contenitore (feature 166). Ordine completo legge anche le
 * distinte delle altre righe; Attuale e prossima non aggiunge letture.
 */
export enum DettaglioPercorso {
  AttualeProssima = 0,
  OrdineCompleto = 1
}

export class AccountOrganizzazione {
  accountId: number;
  organizzazioneId: number;
  userName?: string;
  orgName?: string;
  isActive: boolean; // stato membership (issue #3169): false = disattivata
  tipoInstallazione?: number;
  // Scadenza sessione per operatore (issue #3301): override del valore globale distribuito
  // dall'AuthApi. null/undefined = eredita il globale · 0 = logout automatico disattivato ·
  // > 0 = minuti di inattività. La risoluzione vive in _helpers/inactivity-timeout.ts.
  inactivityTimeoutMinutes?: number | null;
  tipoFiltroOrdini: number;
  activeViewGroup: boolean;
  activeFiltroRisorse: boolean;
  activeFiltroLavorazioni: boolean;
  activeQtaBtn: boolean;
  activeQtaPlusMinusBtn: boolean;
  activeQtaAvvio: boolean;
  activeQtaPausa: boolean;
  activeQtaFine: boolean;
  activeConfirmFine: boolean;
  // Chiusura delle righe/fasi precedenti al Termina fase (issue #3477).
  activeChiudiFasiPrecedenti: boolean;
  activeTranfer: boolean;
  activeConfirmAvanza: boolean;
  activeQtaTotale: boolean;
  activeBoxRequired: boolean;
  activeSkipCq: boolean;
  activeCqRientroTerzista: boolean;
  activeScarto: boolean;
  activeCheckMateriale: boolean;
  activeAvpExt: boolean;
  activeAddMaterialeEsterno: number;
  tipoAvvioRisorse: number;
  tipoModificaLotto: number; // vedi ModalitaModificaLotto
  // Vedi ModalitaModificaQuantita. Opzionale: manca nelle cache localStorage precedenti al rilascio,
  // e il backend lo tratta come «non dichiarato» (preserva il valore a database).
  tipoModificaQuantita?: number;
  // Vedi ModalitaModificaContenitore. Opzionale per lo stesso motivo di tipoModificaQuantita.
  tipoModificaContenitore?: number;
  // Vedi VistaPercorso e DettaglioPercorso (feature 166). Opzionali per lo stesso motivo.
  tipoVistaPercorso?: number;
  tipoDettaglioPercorso?: number;
  groupColumns?: string;
  colonneOrdiniCliente?: string;
  groupColumnsOrdiniCliente?: string;
  colonneListaSpedizioni?: string;
  groupColumnsListaSpedizioni?: string;
  autoLottoCode?: string;
  risorsaUtente?: number;
  codiceOperatore?: string;
  usernameEsolver?: number;
  passwordEsolver?: number;
  // Valori dei campi utente della membership (feature 136). SOLA LETTURA lato client: il backend
  // ignora questo campo nel save generico; si scrive con updateAccountOrganizzazioneCampiUtenteAsync.
  campiUtente?: string;
  // Filtri salvati della Lista Spedizioni (feature 153), JSON {"v":1,…}. SOLA LETTURA come campiUtente:
  // si scrive con updateAccountOrganizzazioneFiltriListaSpedizioniAsync e si legge dal server
  // (getMyAccountSettingsAsync), MAI dalla cache delle impostazioni, che le modali a riga intera
  // riscrivono con copie vecchie.
  filtriListaSpedizioni?: string | null;
}
